import React from "react"; // eslint-disable-line
import logo from "./logo.svg";
import "./App.css";

function App(): JSX.Element {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>Coming Soon</p>
      </header>
    </div>
  );
}

export default App;
